import React from "react"

import { TeamList } from "features/team-management/ui/team-list/TeamList"

import { TeamsOverviewPageProps } from "./TeamsOverviewPage"
import { CreateTeamButton } from "./components/create-team-button/CreateTeamButton"
import "./styles/_teams-overview-page.scss"

interface TeamsOverviewPageViewModel extends TeamsOverviewPageProps {}

export const TeamsOverviewPageView = React.memo(
  ({ teamListModel, onNewTeam }: TeamsOverviewPageViewModel) => {
    return (
      <div className="page teams-overview-page">
        <div className="teams-overview-page__header">
          <h1>Teams Overview</h1>
          <CreateTeamButton onClick={onNewTeam} />
        </div>

        <div className="teams-overview-page__team-list">
          <TeamList {...teamListModel} />
        </div>
      </div>
    )
  }
)
